import YearReview from './YearReview';

const yearReviewContainer = document.querySelector('[data-year-review]');

if (yearReviewContainer) {
    const { lang, year } = yearReviewContainer.dataset;

    const yearReview = new YearReview();
    yearReview.init(lang, year);
}
